<modal-panel title="Filter TMT-ERP Report" (close)="close()">
  <div class="filter" [formGroup]="form">
    <div class="filter__fields" [class.two-col]="!isSmall">

      <mat-form-field>
        <mat-label>Sales Order ID</mat-label>
        <input matInput type="number" formControlName="SalesOrderId" placeholder="e.g. 12345"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Trip Reference (PNR)</mat-label>
        <input matInput formControlName="TripReference" placeholder="e.g. ABCDEF"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>ERP Sales Order</mat-label>
        <input matInput formControlName="ErpOrderNumber" placeholder="e.g. SO-000123"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Client Name</mat-label>
        <input matInput formControlName="ClientName" placeholder="e.g. Smith"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>TMT Created From</mat-label>
        <input matInput readonly [matDatepicker]="createdFrom" formControlName="CreatedDateFrom"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #createdFrom/>
        <mat-datepicker-toggle matIconSuffix [for]="createdFrom"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>TMT Created To</mat-label>
        <input matInput readonly [matDatepicker]="createdTo" formControlName="CreatedDateTo"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #createdTo/>
        <mat-datepicker-toggle matIconSuffix [for]="createdTo"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Sent to ERP From</mat-label>
        <input matInput readonly [matDatepicker]="erpSentFrom" formControlName="ErpSentDateFrom"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #erpSentFrom/>
        <mat-datepicker-toggle matIconSuffix [for]="erpSentFrom"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Sent to ERP To</mat-label>
        <input matInput readonly [matDatepicker]="erpSentTo" formControlName="ErpSentDateTo"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #erpSentTo/>
        <mat-datepicker-toggle matIconSuffix [for]="erpSentTo"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>ERP Response From</mat-label>
        <input matInput readonly [matDatepicker]="erpRespFrom" formControlName="ErpResponseDateFrom"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #erpRespFrom/>
        <mat-datepicker-toggle matIconSuffix [for]="erpRespFrom"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>ERP Response To</mat-label>
        <input matInput readonly [matDatepicker]="erpRespTo" formControlName="ErpResponseDateTo"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #erpRespTo/>
        <mat-datepicker-toggle matIconSuffix [for]="erpRespTo"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Failed Only</mat-label>
        <mat-select formControlName="IsFailed">
          <mat-option [value]="null">All</mat-option>
          <mat-option [value]="true">Failed</mat-option>
          <mat-option [value]="false">Not Failed</mat-option>
        </mat-select>
      </mat-form-field>

    </div>
  </div>
  <ng-container modalPanelFooter>
    <button mat-button (click)="reset()">Reset</button>
    <button mat-raised-button color="primary" (click)="apply()">Apply</button>
  </ng-container>
</modal-panel>
